<template>
  <b-card
    v-if="$can('read', 'trips')"
    class="health-card"
  >
    <h3>Performance</h3>
    <base-overlay :show="fetching">
      <b-row>
        <b-col
          md="6"
          class="d-flex align-items-center"
        >
          <div class="d-flex align-items-center">
            <feather-icon
              icon="CalendarIcon"
              class="mr-1"
            />
            <span class="font-weight-bold mr-1">Joined Days:</span>
            {{ data.joined_days }}
          </div>
        </b-col>
        <b-col
          md="6"
          class="d-flex align-items-center"
        >
          <div class="d-flex align-items-center">
            <feather-icon
              icon="ActivityIcon"
              class="mr-1"
            />
            <span class="font-weight-bold mr-1">Frequency:</span>
            {{ data.frequency }}
          </div>
        </b-col>
      </b-row>
    </base-overlay>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import { BCard, BRow, BCol } from 'bootstrap-vue'
import axiosIns from '@/libs/axios'
import { errorNotification } from '@/utils/toast-notifications'
import BaseOverlay from '@/UI/BaseOverlay.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BaseOverlay,
  },
  props: {
    activeType: {
      activeType: String,
      default: 'driver',
      validator: val => ['driver', 'user'].includes(val),
    },
  },
  setup(props, ctx) {
    const fetching = ref(false)
    const { externalId } = ctx.root.$route.query
    const data = ref({
      frequency: '_',
      joined_days: '_',
    })
    const fetchPerformance = async () => {
      try {
        fetching.value = true
        const res = await axiosIns.get('/trips/performance/segmentation', {
          params: {
            external_id: externalId,
            type: props.activeType,
          },
        })
        data.value = res.data.data
      } catch (error) {
        errorNotification('Failed to fetch Performance')
      } finally {
        fetching.value = false
      }
    }
    fetchPerformance()
    return {
      fetching,
      data,
    }
  },
}
</script>

<style scoped>
.health-card {
  background: #8cabe2;
  color: white;
}
.health-card h3 {
    color: white
}
</style>
